import { TOGGLE_LAYER, SET_OPACITY, SET_BASEMAP } from '../actions/layers'
import { contextualLayers as contextualLayersConfig, basemaps } from '../config'
import { morph } from '../utils'

const defaultState = {
    basemap: basemaps[0],
    contextualLayers: contextualLayersConfig
        .filter(lyr => lyr.visible)
        .map(lyr => ({ id: lyr.id, opacity: lyr.opacity }))
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case SET_BASEMAP:
            if (action.basemap) {
                return morph(state, { basemap: basemaps.find(bm => bm.name === action.basemap) })
            }
            return morph(state, { basemap: basemaps[0] })

        case SET_OPACITY:
            return morph(state, {
                contextualLayers: state.contextualLayers.map(layer => {
                    if (layer.id === action.layer) {
                        return morph(layer, { opacity: action.opacity })
                    }
                    return layer
                })
            })

        case TOGGLE_LAYER:
            if (state.contextualLayers.find(lyr => lyr.id === action.layer)) {
                return morph(state, {
                    contextualLayers: state.contextualLayers.filter(({ id }) => id !== action.layer)
                })
            }

            const layerConfig = contextualLayersConfig.find(lyr => lyr.id === action.layer)
            return morph(state, {
                contextualLayers: [...state.contextualLayers, { id: action.layer, opacity: layerConfig.opacity }]
            })

        default:
            return state
    }
}
